import { Controller } from "@hotwired/stimulus"

// Provides a delightful loading bar + button state when the search form submits.
// The bar animates across the bottom of the search input, and the button
// shows a pulsing state with spinner icon.
export default class extends Controller {
  static targets = ["input", "button", "bar"]

  connect() {
    this.buttonContent = this.buttonTarget.innerHTML
  }

  submit() {
    if (!this.inputTarget.value.trim()) return

    // Show the loading bar
    this.barTarget.classList.remove("opacity-0")
    this.barTarget.classList.add("animate-search-bar")

    // Transform the button into loading state
    this.buttonTarget.disabled = true
    this.buttonTarget.innerHTML = `
      <svg class="animate-spin h-5 w-5" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `
    this.buttonTarget.classList.add("!bg-emerald-700")

    // Add a subtle glow pulse to the entire search container
    this.element.classList.add("search-loading")
  }

  // Restore the form before Turbo caches it or the browser restores a page.
  reset() {
    this.barTarget.classList.add("opacity-0")
    this.barTarget.classList.remove("animate-search-bar")
    this.buttonTarget.disabled = false
    this.buttonTarget.innerHTML = this.buttonContent
    this.buttonTarget.classList.remove("!bg-emerald-700")
    this.element.classList.remove("search-loading")
  }
}
